import { sureco } from 'enrollment-platform/pages/finance/components/shared/finance.styles'
import styled from 'styled-components'

export const StatCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
`

export const HealthPlanStatCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px;
  border-radius: 10px;
  background: ${sureco.white};
  border: 1px solid #eee;
  box-shadow: ${sureco.shadowSm};
`

export const HealthPlanStatCardTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${sureco.fg1};
`

export const HealthPlanStatCardValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: ${sureco.darkBlue};
`

export const HealthPlanStatCardDescription = styled.span`
  font-size: 12px;
  color: ${sureco.fg3};
`
